import { render, staticRenderFns } from "./HandbookList.vue?vue&type=template&id=365c498c&"
import script from "./HandbookList.vue?vue&type=script&lang=js&"
export * from "./HandbookList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports